namespace $.$$ {

	const { rem } = $mol_style_unit

	$mol_style_define( $eve_input_logical_switch_labelled, {
		justifyContent: 'flex-start',
		gap: rem( 0.5 ),
	} )
	
}

